import RegularText from '@/components/RegularText';
import { Box, Icon, InlineStack, Tooltip } from '@shopify/polaris';
import { InfoIcon } from '@shopify/polaris-icons';
import { HeadingStyled } from '../../../styled';

interface Props {
  title: string;
  tooltipContent: string;
  minWidth?: string;
}

export const HeadingInformation = ({ title, tooltipContent, minWidth }: Props) => {
  return (
    <HeadingStyled minWidth={minWidth}>
      <InlineStack gap={'050'} blockAlign="center">
        <RegularText tone="subdued" variant="headingXs">
          {title}
        </RegularText>
        <Tooltip content={tooltipContent} width="wide">
          <Box>
            <Icon source={InfoIcon} />
          </Box>
        </Tooltip>
      </InlineStack>
    </HeadingStyled>
  );
};
